import { render, staticRenderFns } from "./GroupLimitationForm.vue?vue&type=template&id=47670058&"
import script from "./GroupLimitationForm.vue?vue&type=script&lang=ts&"
export * from "./GroupLimitationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports